const toastr = require("toastr");
const toastrOptions = { transitionIn: "fadeIn", transitionOut: "fadeOut", position: "top-right", progressBar: true };

export const emitToastr = (type = "error", title = "", message = "") => {
    return toastr[type](title, message, toastrOptions);
};

export const onlyNumbers = (string) => {
    return /^[0-9]+$/.test(string);
}

export function hexToRGB(value) {
    value = value.replace("#", "");

    return {
        r: parseInt(value.substring(0, 2), 16),
        g: parseInt(value.substring(2, 4), 16),
        b: parseInt(value.substring(4, 6), 16),
    };
}

export function rgbToHSL(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);

    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    }
    else {
        const d = max - min;

        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    h = Math.round(h * 360);
    s = Math.round(s * 100);
    l = Math.round(l * 100);

    return { h, s, l };
}

export function hexToHSL(value) {
    const rgb = hexToRGB(value);

    return rgbToHSL(rgb.r, rgb.g, rgb.b);
}

export function isStaticTemplate(components = []) {
    const MEDIA_HEADER_FORMATS = ["IMAGE", "VIDEO", "DOCUMENT", "LOCATION"];
    let hasParams = false;
    let hasHeaderMedia = false;

    for (const comp of components) {
        // Verifica HEADER e BODY com placeholders
        if ((comp.type === "HEADER" || comp.type === "BODY") && comp.text) {
            if (/\{\{.*?\}\}/.test(comp.text)) {
                hasParams = true;
            }
        }

        // Verifica botões (QUICK_REPLY, URL com {{1}}, etc.)
        if (comp.type === "BUTTONS" && comp.buttons) {
            for (const btn of comp.buttons) {
                if (btn.text && /\{\{.*?\}\}/.test(btn.text)) {
                    hasParams = true;
                }
                if (btn.url && /\{\{.*?\}\}/.test(btn.url)) {
                    hasParams = true;
                }
            }
        }

        // Verifica HEADER com mídia (imagem, vídeo, documento ou localização)
        if (comp.type === "HEADER" && MEDIA_HEADER_FORMATS.includes(comp.format)) {
            hasHeaderMedia = true;
        }
    }

    return !hasParams && !hasHeaderMedia;
}

export function formatPhone(phone, force55 = true) {
    let f_phone = phone.replace(/\D/g, '');
    if (force55 && !f_phone.startsWith("55")) f_phone = `55${f_phone}`;
    return f_phone;
}

export function normalizePhone(countryCode, phone) {
    const ddi = String(countryCode).replace(/\D/g, '');
    let cleaned = String(phone).replace(/\D/g, '');

    // Remove o DDI caso o usuário já tenha digitado o número completo
    // Verifica o comprimento para não confundir DDD 55 com DDI 55
    if (cleaned.startsWith(ddi) && cleaned.length > 11) cleaned = cleaned.slice(ddi.length);

    if (ddi !== '55') return `${ddi}${cleaned}`;

    const ddd = parseInt(cleaned.slice(0, 2), 10);
    let local = cleaned.slice(2);

    const firstDigit = local[0];
    const isLandline = ['2', '3', '4', '5'].includes(firstDigit);

    if (isLandline) {
        local = local.slice(0, 8);
    } else {
        // DDDs 11-19 (SP), 21, 22 e 24 (RJ) e 27 e 28 (ES): primeiros a receber o nono dígito, sempre com 9
        const isNinthDigitRange = ddd >= 11 && ddd <= 28;

        if (isNinthDigitRange) {
            if (local.length === 8 && local[0] !== '9') local = `9${local}`;
            local = local.slice(0, 9);
        } else {
            if (local.length === 9 && local[0] === '9') local = local.slice(1);
            local = local.slice(0, 8);
        }
    }

    return `55${cleaned.slice(0, 2)}${local}`;
}

export function formatCurrency(value) {
    if (!value) return '';
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);
}

export function formatMaskedCurrencyToNumber(maskedValue = '') {    
    const valueStr = maskedValue;
    return parseFloat(valueStr.replace('R$ ', '').replace(/\./g, '').replace(',', '.')) || 0;
}

export function hasHeaderImage(components = []) {
    for (const comp of components) {
        if (comp.type === "HEADER" && comp.format === "IMAGE") return true;
    }
    return false;
}